import { styled } from "styled-components";

import { colorCSS, fontSizes, radius } from "../../styles";

export const Link = styled.a<{
    indicator: "none" | "minor" | "major" | "critical";
}>(
    {
        border: "1px solid transparent",
        borderRadius: radius.button,
        display: "inline-flex",
        fontSize: fontSizes.md,
        padding: "0.4rem 1.5rem 0.5rem",
        textDecoration: "none"
    },
    ({ indicator }) =>
        indicator == "none" &&
        `background-color: ${colorCSS("G400")};
    border-color: ${colorCSS("G400")};
    color: ${colorCSS("N0")};
    &:hover {
      background-color: ${colorCSS("G500")};
      border-color: ${colorCSS("G500")};
      color: ${colorCSS("N0")};
    }`,
    ({ indicator }) =>
        indicator == "minor" &&
        `background-color: ${colorCSS("Y200")};
    border-color: ${colorCSS("Y200")};
    color: ${colorCSS("N900")};
    &:hover {
      background-color: ${colorCSS("Y300")};
      border-color: ${colorCSS("Y300")};
      color: ${colorCSS("N900")};
    }`,
    ({ indicator }) =>
        indicator == "major" &&
        `background-color: ${colorCSS("Y400")};
    border-color: ${colorCSS("Y400")};
    color: ${colorCSS("N900")};
    &:hover {
      background-color: ${colorCSS("Y500")};
      border-color: ${colorCSS("Y500")};
      color: ${colorCSS("N900")};
    }`,
    ({ indicator }) =>
        indicator == "critical" &&
        `background-color: ${colorCSS("R400")};
    border-color: ${colorCSS("R400")};
    color: ${colorCSS("N0")};
    &:hover {
      background-color: ${colorCSS("R500")};
      border-color: ${colorCSS("R500")};
      color: ${colorCSS("N0")};
    }`
);
